import * as z from 'zod';

const SeoZod = z.object({
  metaTitle: z.string(),
  metaDescription: z.string(),
});

export { SeoZod };
export type SeoType = z.infer<typeof SeoZod>;
